import { GetOrgSettingsResponse } from "../../../types/api/org.type";
import httpClient from "../../client/HttpClient";

const OrgService = {
  async getSettings(): Promise<GetOrgSettingsResponse> {
    const response =
      await httpClient.get<GetOrgSettingsResponse>("v1/org/settings");
    return response;
  },
};

export default OrgService;
